module.exports = __webpack_public_path__ + "media/yjnewvideo231024.95ee8b7f.mp4";